import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { EnglishRules, Rules, validationRules } from '@/support/ValidationRules';
import { Brand } from '@/models/Brand'
import { Supplier } from '@/models/Supplier';
import debounce from "debounce";

@Component<CreateDialog>({})
export default class CreateDialog extends Vue {
  @Prop({ default: null })
  protected brand!: Brand;

  protected newBrand: Brand = new Brand();
  protected isLoading: boolean = true;
  protected valid: boolean = false;
  protected rules: Rules = EnglishRules;

  protected suppliers: Supplier[] = [];
  protected supplierSearch: string = "";
  public searchSupplierDebounce: Function = this.handleSupplierSearch();

  protected handleSupplierSearch() {
    return debounce((searchInput: string) => {
      this.getSuppliers(searchInput);
    }, 400);
  }

  protected getSuppliers(filter: string = "") {
    new Supplier()
      .filter("search", filter)
      .limit(100)
      .all()
      .then((suppliers: Supplier[]) => {
        this.suppliers = suppliers;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  mounted() {
    if (this.brand) {
      this.newBrand = this.brand.clone();
    }
    this.getSuppliers();
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }


  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected createOrUpdate() {
    if (this.newBrand.id) {
      this.update();
    } else {
      this.create();
    }
  }

  protected update() {
    this.isLoading = true;
    if (!this.newBrand) {
      return;
    }

    this.newBrand
      .update()
      .then((brand: Brand) => {
        this.isLoading = false;
        this.$emit('brandUpdated', brand);
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected create() {
    if (!this.canSaveBrand) {
      return;
    }

    this.isLoading = true;
    this.newBrand
      .create()
      .then((brand: Brand) => {
        this.isLoading = false;
        this.$emit('brandCreated');
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected get canSaveBrand() {
    if (this.newBrand && this.newBrand.name && this.newBrand.name.length > 0) {
      return true;
    }

    return false;
  }

  protected get saveButtonText() {
    if (this.newBrand && this.newBrand.id) {
      return 'Edit';
    }

    return 'Add';
  }

  protected clear() {
    this.newBrand = new Brand();
  }

  get brandActiveLabel() {
    return this.newBrand.is_active ? "active" : "inactive";
  }

}
